<template>
  <div class="document-summary">
    <h5 class="section-title">📄 Resumen del Documento</h5>
    <b-card class="summary-card">
      <div class="summary-content">
        <div class="summary-icon">{{ icon }}</div>
        <div class="summary-details">
          <div class="summary-row">
            <strong>Tipo:</strong> {{ type.text }} <span class="text-muted">({{ type.value }})</span>
          </div>
          <div v-if="description" class="summary-row">
            <strong>Descripción:</strong> {{ description }}
          </div>
        </div>
      </div>
    </b-card>
  </div>
</template>

<script>
export default {
  name: 'DocumentSummary',
  props: {
    type: {
      type: Object,
      required: true
    },
    icon: {
      type: String,
      required: true
    },
    description: {
      type: String,
      default: ''
    }
  }
};
</script>

<style lang="scss" scoped>
.document-summary {
  margin-bottom: 1.5rem;
  
  .section-title {
    font-size: 1.125rem;
    font-weight: 600;
    color: #2c3e50;
    margin-bottom: 1rem;
  }
  
  .summary-card {
    border: 2px solid #e0e0e0;
    border-radius: 8px;
    
    .summary-content {
      display: flex;
      align-items: center;
      gap: 1.5rem;
      
      .summary-icon {
        font-size: 4rem;
        flex-shrink: 0;
      }
      
      .summary-details {
        flex: 1;
        
        .summary-row {
          margin-bottom: 0.75rem;
          font-size: 1rem;
          line-height: 1.5;
          
          &:last-child {
            margin-bottom: 0;
          }
          
          strong {
            color: #2c3e50;
            margin-right: 0.5rem;
          }
        }
      }
    }
  }
}

@media (max-width: 576px) {
  .document-summary {
    .summary-card {
      .summary-content {
        flex-direction: column;
        text-align: center;
        
        .summary-icon {
          font-size: 3rem;
        }
        
        .summary-details {
          .summary-row {
            font-size: 0.9rem;
          }
        }
      }
    }
  }
}
</style>
